import React from 'react';
import './App.css';
import {Provider} from 'react-redux';
import {createStore, combineReducers} from 'redux';
import {reducer as formReducer} from 'redux-form';
import CalculatorForm from './CalculatorForm';
import CalculatorResult from './CalculatorResult';

const store = createStore(combineReducers({
    form: formReducer,

}), window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

function App() {
    const submit = (values) => {
        console.log(values);
    };
    return (
        <Provider store={store}>
            <CalculatorForm onSubmit={submit}></CalculatorForm>
            <CalculatorResult/>
        </Provider>
    );
}

export default App;
